import { Component, OnInit ,Input} from '@angular/core';
import { MatDialog } from '@angular/material';
import {Router} from '@angular/router'
@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit {
  screenWidth: number;
  dashBoardMessage:any;
  showMenu: boolean = false;
  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  constructor(private router:Router, private matDialog:MatDialog) {
    this.dasboardSetting();   
   }

  ngOnInit(){}
  dasboardSetting(){
    this.dashBoardMessage=this.router.url.replace('/','').charAt(0).toUpperCase()+this.router.url.replace('/','').slice(1)
    this.dashBoardMessage=this.dashBoardMessage.split('/')
    this.dashBoardMessage=this.dashBoardMessage[0];
      // set screenWidth on page load
      this.screenWidth = window.innerWidth;
      window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth; 
      }
}
toggleMenu(){
this.showMenu=!this.showMenu;
this.isShowing=!this.isShowing;
}
}